import { SlotType } from "../../../../utils/interfaces"

import { getOnlineAndOfflineService } from "modules/BookingCommon/common/utils/getOnlineAndOfflineService"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

export function getOnlineOrOfflineFromSurvey(serviceGroup: ServicesGroup, unCheckSlots?: boolean) {
    const formOfWork = SurveyResultsStorage.formOfWork
    if (!formOfWork) return
    const { onlineService, offlineService } = getOnlineAndOfflineService(serviceGroup, unCheckSlots)
    if (onlineService && formOfWork === SlotType.Online) return "online"
    if (offlineService && formOfWork === SlotType.InPerson) return "offline"
}
